/**
 * Refresh the member start-page host after a browser back/forward cache restore.
 *
 * The shared club/person context can change on an overview while the previous
 * dashboard DOM remains in the browser's bfcache. A persisted `pageshow` has no
 * server lifecycle of its own, so trigger one Livewire refresh; HomeTiles then
 * reads the canonical session context in booted().
 */
export default () => ({
  _pageShowHandler: null,

  init() {
    this._pageShowHandler = (event) => {
      if (!event.persisted) {
        return
      }

      this.$nextTick(() => this.$wire.$refresh())
    }

    window.addEventListener('pageshow', this._pageShowHandler)
  },

  destroy() {
    if (this._pageShowHandler) {
      window.removeEventListener('pageshow', this._pageShowHandler)
      this._pageShowHandler = null
    }
  }
})
